// extracted by mini-css-extract-plugin
export var auto = "_39-1";
export var spinner = "_39-0";